import React, {Fragment} from "react";
import { getFormInformation,handleErrorResponse,randstr,showToast } from "../../Common/Appcommon";
import requestApi from "../../services/requestApi.service";
import TagEdit from "../Tags/TagEdit";

class TagOperations extends React.Component{

    formname = process.env.REACT_APP_TAG_FORMNAME;

    constructor(props) {
        super(props);

        this.state = {
            showModal : props.showActionModal,
            tagId : props.tagId,
            tagInfo : {}
        }
    }

    async componentDidMount() {
        let { tagId, tagInfo } = this.state;

        let formResponse = await getFormInformation(tagId, this.formname);
        if(formResponse.issuccess){
            tagInfo = formResponse.data;
        } else if (formResponse.errormsg !== ""){
            showToast(formResponse.errormsg,"top-right","error");
        }
        this.setState({ tagInfo });
    }

    onTagSave = async (data) => {

        let { tagId } = this.state;

        let params = {
            "ENTITY": "WHATSAPPPROCESS",
            "FORMINPUT" : data,
            "isOtherApiReq" : true,
            "FORMNAME" : this.formname
        }

        if(tagId !== undefined && tagId !== '' && tagId !== null){
            params['OPERATION'] = 'UPDATE_TAG';
            params['FORMID'] = tagId;
        }else{
            params['OPERATION'] = 'CREATE_TAG';
        }

        let res = await requestApi.processServerRequest(params,"WebV2","post");
        if(res.issuccess){
            tagId = res.data[0];
                if(params['OPERATION'] === 'CREATE_TAG'){
                    showToast(`Tag created successfully`);
                }else{
                    showToast(`Tag updated successfully`);
                }
        }else{
            handleErrorResponse(res.errormsg);
        }

        this.props.toggleActionsModal(false,tagId,true);
    }

    onTagCancel = () => {
        this.props.toggleActionsModal(false);
    }


    render() {

        let { showModal, tagId, tagInfo } = this.state;

        return(
            <Fragment>
                <TagEdit
                    key={randstr(`tag_edit`)}
                    showModal={showModal}
                    formId={tagId}
                    onSave={this.onTagSave}
                    oncancel={this.onTagCancel}
                    tagId={tagId}
                    tagData={tagInfo}
                />
            </Fragment>
        );
    }

}

export default TagOperations;